// utils/initWellLayer.js
import { APP_CONFIG, LOG_MODULES,IS_DEV,SERVICE_KEYS, FAIL_SECURE_DEF_EXPRESS } from '@config/config';
import { MapServices } from '@config/mapLayers/serviceMapListApp';
import { FeatureServices } from '@config/mapLayers/serviceFeatureListApp';
import { log } from '@libs/utils/helper.js';
import buildWellLayerAdaptiveCluster from './wellLayerAdaptiveCluster';
import {wireLayerDiagnostics} from "./debugLayerSwitch.js"

import { loadMapResources } from '@config/mapLayers/mapLayerUtils';
const isNeedLog = true;
const WellMapper=LOG_MODULES.WELLARCGISMAPPER;
// utils/initWellLayer.js

export function initWellLayer(map, view, isInitialPositionSetRef,defExpress) {
  if (!map || !view) return;

  
  if(isNeedLog) log(WellMapper, `[initWellLayer] Evaluated safe expressions`,defExpress);
  //console.error(`00000000  [initWellLayer] Evaluated defExpress`,defExpress);
  // 1. Load general resources first
  loadMapResources(map, {
    mapServices: Object.values(MapServices),
    defExp: defExpress,   
    // FeatureServices handled manually below (needs adaptive clustering, not generic load)
    features: Object.values(FeatureServices),
  });

  // 2. Positioning
  if (!isInitialPositionSetRef.current) {
    view.center = APP_CONFIG.MAPS.Well.center;
    view.zoom = APP_CONFIG.MAPS.Well.appZoom;
    isInitialPositionSetRef.current = true;
  }

  // 3. Prevent duplicate layers
  const layerId = APP_CONFIG.MAPS.Well.id; 
  let wellLayer = map.findLayerById(layerId);

  if (!wellLayer) {
    const securedFeatureConfig = {
      ...FeatureServices.Niogems5_Wells,
      definitionExpression: defExpress[SERVICE_KEYS.NIOGEMS_MAP_SERVICES]
    };

    wellLayer = buildWellLayerAdaptiveCluster(view, securedFeatureConfig);
    // Ensure the layer is added to the bottom or a specific index if needed
    map.add(wellLayer);
    if(isNeedLog) log(WellMapper, `Layer ${layerId} added to map.`);
  }
  
  // better //for test purpose, it will be commented out
  if (IS_DEV) {
    log(WellMapper,"initWellLayer In the DEV mode  start debug Layer:")
    //wireLayerDiagnostics(map, view, { imageLayerId: "Wells-Image", featureLayerId: layerId });
  }
  return wellLayer;
}